import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './editClientsBox.css';
import { Button } from './Button';
import { ClientsService } from '../services/supabase/clientsService';

export const EditClientsBox = (props) => {

  const [showingDeactivated, setShowingDeactivated] = useState(false);
  const [inputs, setInputs] = useState({});
  const [statusMsg, setStatusMsg] = useState({ text: '', color: '' });

  const sortedClients = useMemo(() =>
    [...props.clientList].sort((a, b) => a.name.localeCompare(b.name)),
    [props.clientList]
  );

  const getInput = (clientId, field, fallback) => {
    if (inputs[clientId] && inputs[clientId][field] !== undefined) return inputs[clientId][field];
    return fallback;
  };

  const setField = (clientId, field, value) =>
    setInputs(prev => ({ ...prev, [clientId]: { ...prev[clientId], [field]: value } }));

  const handleUpdate = async (client) => {
    const rate = parseFloat(getInput(client.docID, 'rate', client.rate[0]));
    const datePart = getInput(client.docID, 'dateEffective', '');
    const rateEffectTime = new Date(datePart).getTime();

    try {
      await ClientsService.updateRate(client.docID, rate, rateEffectTime);
      setStatusMsg({ text: 'Client updated successfully.', color: 'green' });
      props.InitialLoadClients();
    } catch (error) {
      console.error('Error updating client rate:', error);
      setStatusMsg({ text: 'Error updating client information.', color: 'red' });
    }
  };

  const handleDelete = (client) => {
    props.setClientToDeleteID(client.docID);
    props.setClientToDeleteName(client.name);
    props.setDisplayDeleteClientDialog(true);
  };

  return (
    <div className="editClientsDiv" id="editClientsTarget">
      <h2>Edit Clients</h2><br />

      <Button
        onClick={() => setShowingDeactivated(v => !v)}
        type="button"
        buttonStyle="btn--success--solid"
        buttonSize="btn--medium"
      >
        {showingDeactivated ? 'Hide Deactivated Clients' : 'Show Deactivated Clients'}
      </Button>

      {showingDeactivated && (
        <table id="deactivatedClientsTable">
          <thead>
            <tr>
              <td>Name</td>
              <td>Rate</td>
              <td>Set to &apos;Deactivated&apos; on:</td>
            </tr>
          </thead>
          <tbody>
            {props.deactivatedClientsList.map(deactiv => {
              const d = new Date(deactiv.deactivationTime);
              const dateStr = `${d.getMonth()+1}/${d.getDate()}/${d.getFullYear()}`;
              return (
                <tr key={deactiv.docID} className="deactivClientTR">
                  <td className="deactivTD">{deactiv.name}</td>
                  <td className="deactivTD">{deactiv.rate[0]}</td>
                  <td className="deactivTimeTD">{dateStr}</td>
                  <td>
                    <button
                      type="button"
                      className="updateClientButton"
                      onClick={() => props.restoreClient(deactiv)}
                    >
                      Reactivate
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="deleteClientButton"
                      onClick={() => handleDelete(deactiv)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      <div className="formSep"></div>
      <p id="editClientStatusMsg" style={{ minHeight: '1.2em', color: statusMsg.color }}>{statusMsg.text}</p>

      <table id="clientEditBoxTable">
        <thead>
          <tr>
            <td>Name</td>
            <td>Rate</td>
            <td>!!! Required !!! - Date new rate takes Effect</td>
          </tr>
        </thead>
        <tbody>
          {sortedClients.map(client => (
            <tr key={client.docID}>
              <td id={`clientNameData${client.name}`} className="clientNameData">
                <Link
                  to={`/client/${encodeURIComponent(client.name)}`}
                  style={{ color: 'inherit', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {client.name}
                </Link>
              </td>
              <td>
                <input
                  className="clientRateInput"
                  value={getInput(client.docID, 'rate', client.rate[0])}
                  onChange={e => setField(client.docID, 'rate', e.target.value)}
                />
              </td>
              <td>
                <input
                  type="date"
                  className="clientRateDate"
                  value={getInput(client.docID, 'dateEffective', '')}
                  onChange={e => setField(client.docID, 'dateEffective', e.target.value)}
                />
              </td>
              <td id="updateClientButtonTD">
                <button
                  type="button"
                  className="updateClientButton"
                  onClick={() => handleUpdate(client)}
                >
                  Update
                </button>
              </td>
              <td id="deleteClientButtonTD">
                <button
                  type="button"
                  className="deleteClientButton"
                  onClick={() => handleDelete(client)}
                >
                  Delete / Deactivate
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
